import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AutoCalculationConfiguration, AUTO_CALC_CONFIGS_TOKEN } from './auto-calculation.token';

/**
 * Root module for the auto-calculation library. Mirrors `StackingPlanModule.forRoot`.
 *
 * @example
 * AutoCalculationModule.forRoot({ columnIdMap: new BuiltInColumnIdMap(), round: hostRound })
 */
@NgModule({
  imports: [CommonModule],
})
export class AutoCalculationModule {
  static forRoot(config: AutoCalculationConfiguration): ModuleWithProviders<AutoCalculationModule> {
    return {
      ngModule: AutoCalculationModule,
      providers: [{ provide: AUTO_CALC_CONFIGS_TOKEN, useValue: config }],
    };
  }
}
